import $ from 'jquery';
const { registerBlockType } = wp.blocks;
const {
  RichText,
  MediaUpload,
  MediaUploadCheck,
  InspectorControls,
  URLInputButton,
} = wp.blockEditor;
const { Button, Icon, PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect } = wp.element;
const { __ } = wp.i18n;

const BlockEdit = ({ attributes, setAttributes }) => {
  const {
    sectionTitle,
    sectionEyebrow,
    cards,
    sectionClass,
    cornerPositionClass,
    cornerBackgroundClass,
    cornerUrl,
  } = attributes;

  const addCard = () => {
    const newCards = [
      {
        imgUrl: '',
        imgAlt: '', // Added imgAlt field for the alt attribute
        label: '',
        title: '',
        buttonUrl: '',
      },
      ...cards,
    ];
    setAttributes({ cards: newCards });
  };

  const removeCard = (index) => {
    const newCards = cards.filter((_, i) => i !== index);
    setAttributes({ cards: newCards });
  };

  const updateCard = (index, updates) => {
    const newCards = cards.map((card, i) =>
      i === index ? { ...card, ...updates } : card
    );
    setAttributes({ cards: newCards });
  };

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__('Offerings Section Settings')}>
          <Button isPrimary onClick={addCard}>
            <Icon icon="insert" /> {__('Add Card')}
          </Button>
          <URLInputButton
            label={__('Right Corner URL')}
            url={cornerUrl}
            onChange={(url) => setAttributes({ cornerUrl: url })}
          />
          <SelectControl
            label={__('Section Class')}
            value={sectionClass}
            options={[
              { label: 'Dark Secondary', value: 'section-dark-secondary' },
              { label: 'Dark Primary', value: 'section-dark-primary' },
              { label: 'Light Primary', value: 'section-light-primary' },
              { label: 'Light Secondary', value: 'section-light-secondary' },
            ]}
            onChange={(value) => setAttributes({ sectionClass: value })}
          />
          <SelectControl
            label={__('Corner Position')}
            value={cornerPositionClass}
            options={[
              { label: 'None', value: 'corner-disabled' },
              { label: 'Left-Top', value: 'corner-left-top' },
              { label: 'Left-Bottom', value: 'corner-left-bottom' },
              { label: 'Right-Top', value: 'corner-right-top' },
              { label: 'Right-Bottom', value: 'corner-right-bottom' },
            ]}
            onChange={(value) => setAttributes({ cornerPositionClass: value })}
          />
          <SelectControl
            label={__('Corner Background')}
            value={cornerBackgroundClass}
            options={[
              { label: 'Dark Primary', value: 'corner-on-dark-primary' },
              { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
              { label: 'Light Primary', value: 'corner-on-light-primary' },
              { label: 'Light Secondary', value: 'corner-on-light-secondary' },
            ]}
            onChange={(value) =>
              setAttributes({ cornerBackgroundClass: value })
            }
          />
        </PanelBody>
      </InspectorControls>
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <div className="offerings-section-wrapper">
          <div className="content-container">
            <RichText
              tagName="p"
              className="eyebrow"
              value={sectionEyebrow}
              onChange={(eyebrow) => setAttributes({ sectionEyebrow: eyebrow })}
              placeholder={__('Our offerings')}
            />
            <RichText
              tagName="h2"
              value={sectionTitle}
              onChange={(title) => setAttributes({ sectionTitle: title })}
              placeholder={__('Discover more of our offerings')}
            />
            <div className="cards-list">
              {cards.map((card, index) => (
                <div className="card" key={index}>
                  <MediaUploadCheck>
                    <MediaUpload
                      onSelect={
                        (media) =>
                          updateCard(index, {
                            imgUrl: media.url,
                            imgAlt: media.alt || '',
                          }) // Capture imgAlt
                      }
                      allowedTypes={['image']}
                      value={card.imgUrl}
                      render={({ open }) => (
                        <Button
                          onClick={open}
                          isPrimary
                          isSmall
                          className={'centeredFullButton'}
                        >
                          {card.imgUrl ? (
                            <>
                              <Icon icon="edit" /> {__('Change Image')}
                            </>
                          ) : (
                            <>
                              <Icon icon="format-image" /> {__('Add Image')}
                            </>
                          )}
                        </Button>
                      )}
                    />
                  </MediaUploadCheck>
                  {card.imgUrl && (
                    <Button
                      isSmall
                      isDestructive
                      className={'rightTopButton'}
                      onClick={() =>
                        updateCard(index, { imgUrl: '', imgAlt: '' })
                      }
                    >
                      <Icon icon="trash" /> {__('Remove Image')}
                    </Button>
                  )}
                  {card.imgUrl && (
                    <img src={card.imgUrl} alt={card.imgAlt || ''} />
                  )}{' '}
                  {/* Use imgAlt */}
                  <div className={'urlInputTop'}>
                    <URLInputButton
                      url={card.buttonUrl}
                      onChange={(url) => updateCard(index, { buttonUrl: url })}
                    />
                  </div>
                  <div className="title">
                    <div className="top">
                      <RichText
                        tagName="div"
                        className={'label'}
                        value={card.label}
                        placeholder={__('Label')}
                        onChange={(label) => updateCard(index, { label })}
                        keepPlaceholderOnFocus={true}
                      />

                      <a
                        href={'#'}
                        title={card.label}
                        className="btn btn-solid btn-light btn-icon"
                      ></a>
                    </div>
                    <RichText
                      tagName="h3"
                      value={card.title}
                      onChange={(title) => updateCard(index, { title })}
                      placeholder={__('Title')}
                    />
                  </div>
                  <Button
                    isSmall
                    isDestructive
                    className={'rightBottomButton'}
                    onClick={() => removeCard(index)}
                  >
                    <Icon icon="trash" /> {__('Remove Card')}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

registerBlockType('pg/offerings-section', {
  title: 'PG Offerings Section',
  icon: 'screenoptions',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    sectionTitle: {
      type: 'string',
      source: 'html',
      selector: 'h2',
    },
    sectionEyebrow: {
      type: 'string',
      source: 'html',
      selector: 'p.eyebrow',
    },
    cards: {
      type: 'array',
      default: [],
    },
    sectionClass: {
      type: 'string',
      default: 'section-dark-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    cornerUrl: {
      type: 'string',
      default: '',
    },
  },
  edit: BlockEdit,
  save: ({ attributes }) => {
    const {
      sectionTitle,
      sectionEyebrow,
      cards,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      cornerUrl,
    } = attributes;

    return (
      <section className={sectionClass}>
        <div
          className={`corner ${cornerPositionClass} ${sectionClass.replace(
            'section',
            'corner'
          )} ${cornerBackgroundClass}`}
        ></div>
        <div className="offerings-section-wrapper">
          <div className="content-container">
            <RichText.Content
              tagName="p"
              className="eyebrow"
              value={sectionEyebrow}
            />
            <RichText.Content tagName="h2" value={sectionTitle} />
            <div className="cards-list">
              {cards.map((card, index) => (
                <div className="card" key={index}>
                  {card.imgUrl && (
                    <img src={card.imgUrl} alt={card.imgAlt || ''} />
                  )}{' '}
                  {/* Use imgAlt */}
                  <div className="title">
                    <div className="top">
                      {card.label && (
                        <RichText.Content
                          tagName="div"
                          className="label"
                          value={card.label}
                        />
                      )}
                      <a
                        href={card.buttonUrl}
                        className="btn btn-solid btn-light btn-icon"
                      ></a>
                    </div>
                    <RichText.Content tagName="h3" value={card.title} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  },
});
